export default __webpack_public_path__ + "static/media/Start-working-on-Application-with-ease.2ff8c585.png";